import {FormItemConfigurationModel} from './form-item-configuration.model';
import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';
import {XauditModel} from '../xaudit.model';

export class FormParagraphConfigurationModel extends XauditModel {
    DFormParagraphId: string;
    DFormVersionId: string;
    ParagraphName: string;
    isRepeting: boolean;
    isFillForward: boolean;
    RepeatDFormItemId: string;
    enumParagraphOrientationID: string;
    MaximumColumnCount: number;
    MaximumRowCount: number;
    ParagraphIndent: number;
    enumItemLayoutID: string;
    isFirstRowHeader: boolean;
    HeaderHeight: number;
    ParagraphOrder: number;
    PageBreakAfter: boolean;
    RepeatDFormItem: FormItemConfigurationModel;
    cfgDFormItems: FormItemConfigurationModel[];
    enumParagraphOrientation: EnumValidValueItemModel;
    enumItemLayout: EnumValidValueItemModel;
}
